export enum DeleteDialogContext {
  model = 'model',
  layout = 'layout'
}
